import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import About from './components/About';
import Contact from './components/Contact';
import Topics from './components/Topics';
import Updates from './components/Updates';
import FAQ from './components/FAQ';
import Index from './components/Index';
import Cards from './components/Cards';
import MediaSection from './components/MediaSection';
import Carousel from './components/Carousel';
import Ranking from './components/Ranking';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '关于我们', href: '#about' },
  { label: '主题合集', href: '#index' },
  { label: '最新快讯', href: '#updates' },
  { label: '深度专题', href: '#carousel' },
  { label: '投稿爆料', href: '#contact' },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header navItems={navItems} />
      <main>
        <Hero />
        <Features />
        <About />
        <Contact />
        <Topics />
        <Updates />
        <FAQ />
        <Index />
        <Cards />
        <MediaSection />
        <Carousel />
        <Ranking />
        <CommentsSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}